import { ITealiumWindow } from "./TealiumTypes";

const UtagWindow = window as ITealiumWindow;
const utag = UtagWindow.utag;

export { utag };
